export default __webpack_public_path__ + "static/media/hbase.4216016a.svg";